import { Injectable } from '@angular/core';
import { environment } from '@environments/_current/environment';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class Logger {
  log(message: string): void {
    console.log(message);
  }

  info(message: string): void {
    console.info(`info | ${environment.serverEnvironment} ${message}`);
  }

  error(message: string): void {
    console.error(`error | ${environment.serverEnvironment} ${message}`);
    Sentry.captureException(new Error(message));
  }

  warn(message: string): void {
    console.warn(`warn | ${environment.serverEnvironment} ${message}`);
  }
}
